export const activeStateStyles = (active) => {
  if (active) {
    return { color: "#fff", backgroundColor: "#fe6551" };
  }
  return {};
};
